import React, { useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers } from "@fortawesome/free-solid-svg-icons";
import ActiveTriageSection from "./ActiveTriageSection";
import { useCareHubData, normalizeCareHubRange } from "../../hooks/useCareHubData";
import { Link, useSearchParams } from "react-router-dom";
import { filterTriageWorkflow } from "../../utils/careTriageModel";
import "./CareHubPages.css";

const CareDashboardPage = (bannerProps) => {
  const [searchParams] = useSearchParams();
  const changeRange = normalizeCareHubRange(searchParams.get("range"));

  const { loading, error, summary, triageCases } = useCareHubData(
    bannerProps.activeLocation,
    bannerProps.locations,
    changeRange,
  );

  const overdueCount = useMemo(
    () => filterTriageWorkflow(triageCases, "overdue").length,
    [triageCases],
  );

  const activeClientCount = loading ? "—" : summary.activeClients;

  return (
    <div className="care-dashboard">
      <header className="care-dashboard__header">
        <div className="care-dashboard__intro">
          <h1 className="care-dashboard__title">Care Dashboard</h1>
          <p className="care-dashboard__subtitle">
            Monitor client stability and triage activity across your population.
          </p>
        </div>
        <Link
          to="/client-management"
          className="care-dashboard__stat care-dashboard__stat--link"
          aria-live="polite"
          aria-label={`${activeClientCount} active clients — view all clients`}
        >
          <span className="care-dashboard__stat-icon" aria-hidden="true">
            <FontAwesomeIcon icon={faUsers} />
          </span>
          <div className="care-dashboard__stat-copy">
            <div className="care-dashboard__stat-value">{activeClientCount}</div>
            <div className="care-dashboard__stat-label">Active Clients</div>
          </div>
        </Link>
      </header>

      {error ? (
        <div className="care-hub-alert care-hub-alert--error" role="alert">
          {error}
        </div>
      ) : null}

      {loading ? (
        <div className="care-hub-loading">Loading care dashboard…</div>
      ) : (
        <ActiveTriageSection summary={summary} overdueCount={overdueCount} />
      )}
    </div>
  );
};

export default CareDashboardPage;
